export const ultimasNoticias = [
    
   //   {
   //      "imagen" : "assets/imgs/comisionpermanente.jpeg",

   //      "url" : "https://www.facebook.com/photo.php?fbid=1141667654661088&set=pb.100064535929070.-2207520000&type=3&locale=es_LA",
   //      "titulo" : "Contralores México",
       
   //     "fecha" : "Contralores México",
   //   }, 
   //   {
   //      "imagen" : "assets/imgs/CONTRALORIASOCIAL12.jpg",

   //      "url" : "https://www.facebook.com/share/p/1F7xuoj15B/",
   //      "titulo" : "Premio Nacional de Contralores ",
       
   //     "fecha" : "Contraloría Social",
   //   }, 


   //   {
   //      "imagen" : "assets/imgs/convocsatorias (2).jpg",
   //      "url" : "https://s-contraloria.hidalgo.gob.mx/interes/Convocatoria-Transparencia-en-Corto-2025.pdf",

   //      "titulo" : "Premio Nacional de Contralores ",
   //       "fecha" : "Contraloría Social",
   //  }, 

 
    {
        "imagen" : "assets/imgs/eticasp.jpg",
        "url" : "https://www.facebook.com/share/p/1JUFScmcau",
        "titulo" : "Secretaría de Contraloría Hidalgo",
        "fecha" : "“Ética en el Servicio Público”.",
    },

    
     {
        "imagen" : "assets/imgs/rutastransformacion1.jpg",
        "url" : "https://www.facebook.com/share/p/1Gj6sgX779",
        "titulo" : "Secretaría de Contraloría Hidalgo",
       "fecha" : "Rutas de la Transformación.",    
       
    }, 
    
    {
        "imagen" : "assets/imgs/organosvigilancia.jpg",
        "url" : "https://www.facebook.com/share/p/1Vg7ZWTjLR",
        "titulo" : "Secretaría de Contraloría Hidalgo",
       "fecha" : "La Contraloría estuvo presente en #Xochicoatlán.",
    },     
  
    {
        "imagen" : "assets/imgs/superagentes2.jpg",
         "url" : "https://www.facebook.com/share/p/1BiM3NYSYm",
        "titulo" : "Secretaría de Contraloría Hidalgo",
       "fecha" : "Los Súper Agentes de la Contraloría .",
    },
   

     {
        "imagen" : "assets/imgs/direresponsabilidades.jpg",
        "url" : "https://www.facebook.com/share/p/18VEuiPAe8",
        "titulo" : "Secretaría de Contraloría Hidalgo",
       "fecha" : "“Prevención de Conflictos de Interés y Responsabilidades Administrativas”.",
    },
    {
        "imagen" : "assets/imgs/AUDITORIACEVI.jpg",
         "url" : "https://www.facebook.com/share/p/1D42w7zA8m",
        "titulo" : "Secretaría de Contraloría Hidalgo",
       "fecha" : "Auditoría a la Comisión Estatal de Vivienda Hidalgo - CEVI.",
    },

 
 
 
    // {
    //     "imagen" : "noticias/comision.gif",
    //      "url" : "https://comisioncontralores.gob.mx/2023/",
    //     "titulo" : "Comisión Permanente de Contralores ",
    //    "fecha" : "Estados-Federación",
    // },     

    // {
    //     "imagen" : "noticias/9_jornada.jpg",
    //      "url" : "https://www.facebook.com/SecretariaContraloriaHgo/videos/1141123597339219/?mibextid=rS40aB7S9Ucbxw6v",
    //     "titulo" : "9 JORNADA DE CAPACITACIÓN ",
    //    "fecha" : "PARA LA TRANSFORMACIÓN DE HIDALGO",
    // },
    // {
    //     "imagen" : "noticias/convenio.jpg",
    //     "url" : "https://www.facebook.com/SecretariaContraloriaHgo/videos/1156571106119065",
    //     "titulo" : "Firma de Convenio de Donación de Sistemas por la Secretaría de la Honestidad ",
    //     "fecha" : "y la Secretaría de Contraloría de Hidalgo."
    // },
   


    // {
    //     "imagen" : "noticias/2da sesion.png",
    //     "url" : "https://www.facebook.com/share/p/14qTV3iovd/?mibextid=WC7FNe",
    //     "titulo" : " Segunda Asamblea Plenaria de la Comisión Permanente de Contralores Estado-Municipios",
    //     "fecha" : "28 de noviembre del 2024"
    // },



]